<template>
  <div>
    <el-card class="file-infos">
      <div slot="header"
           class="clearfix">
        <span>{{ $t('docMgt.folderInfo') }}</span>
      </div>
      <el-form ref="form" :model="fileInfo" label-width="100px">
        <el-form-item label="父文件夹名称">
          <div style="text-align: left">{{ fileInfo.parentFolderName }}</div>
        </el-form-item>
        <el-form-item :label="$t('docMgt.parFolderName')">
          <el-input v-model="name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('docMgt.docNum')">
          <el-input v-model="code"></el-input>
        </el-form-item>
        <el-form-item :label="$t('docMgt.docSize')">
          <el-input :disabled="true" v-model="fileInfo.newFolderSize"></el-input>
        </el-form-item>
        <el-form-item :label="$t('docMgt.createTime')">
          <el-input :disabled="true" v-model="fileInfo.FolderCreateTime"></el-input>
        </el-form-item>
        <el-form-item :label="$t('docMgt.createUser')">
          <el-input :disabled="true" v-model="fileInfo.FolderCreateOperatorName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('docMgt.modifyTime')">
          <el-input :disabled="true" v-model="fileInfo.FolderModifyTime"></el-input>
        </el-form-item>
        <el-form-item :label="$t('docMgt.modifyUser')">
          <el-input :disabled="true" v-model="fileInfo.FolderModifyOperatorName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('docMgt.mark')">
          <el-input v-model="remark"></el-input>
        </el-form-item>
      </el-form>
      <el-form>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">{{ $t('dataInput.save') }}</el-button>
          <el-button @click="cancle">{{ $t('dataInput.cancel') }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import ApiService from '@/services/API-services'
export default {
  name: 'folderInfo',
  props: ['modalInfo'],
  data() {
    return {
      fileInfo: null,
      name: null,
      code: null,
      remark: null
    }
  },
  created() {
    this.fileInfo = this.modalInfo
    this.name = this.modalInfo.FolderName
    this.code = this.modalInfo.FolderCode
    this.remark = this.modalInfo.FolderRemark
  },
  methods: {
    cancle() {
      this.$store.commit('reloadFile', Math.random())
      this.$store.commit('closeModal', 'folderInfo')
    },
    onSubmit() {
      let params = new FormData()
      params.append('module', 'WebClient')
      params.append('fun', 'ChangeFolderInfo')
      params.append('newName', this.name)
      params.append('folderId', this.fileInfo.FolderId)
      params.append('folderCode', this.code)
      params.append('remark', this.remark)
      params.append('secretLevel', this.fileInfo.SecurityLevelId)
      ApiService.oct_doc.common(params).then(res => {
        this.cancle()
      })
    }
  }
}
</script>
<style lang="scss">
.file-infos {
  .el-card__body {
    width: 600px;
    height: 500px;
    overflow: auto;
    .el-select {
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mind/folderInfo.vue